import { YupSchema } from 'services/yup/types'
import { optionedProductVS } from './optionedProduct'
import { yupIgnore, yupNumber } from 'services/yup'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { Experience } from 'services/api/entities/catalog/experience/types/internal/experience-models'

export const experienceVS: YupSchema<Experience, APIPriceRange[] | undefined> =
  optionedProductVS.shape({
    maxQuantity: yupNumber(),
    skillFacet: yupIgnore(),
    tagFacets: yupIgnore(),
  })
